export default String.raw`
.comparison__dialog {
    max-width: 768px;
    max-height: 492px;
    width: 768px;

    .dialog {
        &__header {
            gap: 16px;

            &-wrapper {
                display: flex;
                gap: 16px;
                align-items: center;
                
                > svg {
                    align-self: flex-start;
                    fill: #008945;
                    flex-shrink: 0;
                }
            }

            &-info {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                gap: 8px;
            }

            &-title {
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
            }

            &-decription {
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
            }

            .comparison__items {
                margin-left: auto;
            }

            form[method="dialog"] {
                align-self: flex-start;
                margin-left: auto;
            }

            &.limit {
                padding: 32px 32px 24px 32px;
            }
        }

        &__content {
            padding: 32px 32px 0 32px;
            gap: 16px;

            &.limit {
                padding: 0 32px;
            }
        }

        &__actions {
            width: 100%;
            justify-content: space-between;
            padding: 32px;

            .primary-action-button {
                display: inline-flex;
            }
        }
    }
}

.comparison__list {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0;
    padding: 0;
    gap: 16px;
    overflow: auto;
    min-height: 90px;

    .product {
        &__image {
            max-width: 100%;
            height: auto;
            max-height: 100%;
            object-fit: contain;

            &-wrapper {
                width: 80px;
                height: 80px;
                aspect-ratio: 1;
                border-radius: 4px;
                align-content: center;
            }
        }
    }

    &-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;

        &-info {
            display: flex;
            width: 100%;
            flex-direction: column;
            gap: 16px;
            overflow: hidden;

            p {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                @include body-1-medium;
            }
        }

        &-attributes {
            display: inline-block;
            width: 100%;
            gap: 8px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;

            .attribute {
                @include body-1-regular;
                margin-right: 8px;

                b {
                    @include body-1-semi-bold;
                }
            }
        }
    }
}
`